var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-container"},[_c('h2',{class:_vm.headingClass},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('button',{staticClass:"btn",on:{"click":_vm.onNextButton}},[_vm._v("\n        Next\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }